var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "slide-box " + ("cur_" + _vm.cur_idx) },
    [
      _c(
        "div",
        {
          class: "slider to-l " + (_vm.cur_idx == 0 ? "disabled" : ""),
          on: { click: _vm.to_left }
        },
        [_c("img", { attrs: { src: _vm.left_pic } })]
      ),
      _vm._v(" "),
      _c("div", { class: "slider to-r", on: { click: _vm.to_right } }, [
        _c("img", { attrs: { src: _vm.right_pic } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "speaker-box" }, [
        _c("img", {
          staticClass: "speaker",
          attrs: { src: _vm.speaker },
          on: { click: _vm.play }
        }),
        _vm._v(" "),
        _c("video", {
          staticClass: "cur-video",
          attrs: {
            src: _vm.list[_vm.cur_idx].voice,
            controls: "",
            autoplay: ""
          }
        })
      ]),
      _vm._v(" "),
      _vm._l(_vm.list, function(item, idx) {
        return _c(
          "div",
          { class: "slide-card " + _vm.slide_status(idx) + (" idx_" + idx) },
          [
            _c("img", { attrs: { src: item.pic, alt: item.title } }),
            _vm._v(" "),
            _c("video", { attrs: { src: item.voice, controls: "" } })
          ]
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "indicator" }, [
        _vm._v(_vm._s(_vm.cur_idx + 1) + "/" + _vm._s(_vm.list.length))
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "skip",
          attrs: { title: "跳过" },
          on: { click: _vm.skip }
        },
        [_vm._v("↷")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }